// import React from "react";

// export default function Hero() {
//   return (
//     <section
//     id="hero"
//     className="h-screen flex items-center justify-center text-white text-center px-6"
//     // style={{ background: "linear-gradient(to bottom right, #4f46e5, #9333ea)" }}
//     style={{
//       background: "linear-gradient(to bottom right, rgb(15, 13, 61), rgb(33, 30, 133), rgb(15, 13, 61))"
//     }}>
//       <div className="max-w-3xl">
//         <h1 className="text-6xl font-extrabold mb-6 leading-tight text-white">
//         Empower Your Business with{" "}
//         <span className="text-yellow-500">Expert Consulting</span>
//         </h1>
//         <p className="text-2xl mb-8">Get your projects and operations checked for better efficacy and optimized performance.</p>
//         <div className="flex flex-wrap gap-4 justify-center mt-6">
//           <a
//             href="#contact"
//             className="bg-green-600 text-white font-semibold py-3 px-6 rounded-md shadow-lg hover:bg-green-700 transition"
//           >
//             Get In Touch
//           </a>
//           <a
//             href="#services"
//             className="bg-yellow-400 text-blue-900 font-semibold py-3 px-6 rounded-md shadow-lg hover:bg-yellow-600 transition"
//           >
//             Our Services
//           </a>
//         </div>

//       </div>
//     </section>
//   );
// }
import React from "react";

export default function Hero() {
  return (
    <section
      id="hero"
      className="min-h-screen pt-24 flex items-center justify-center text-white text-center px-4 md:px-6"
      style={{
        background: "linear-gradient(to bottom right, rgb(15, 13, 61), rgb(33, 30, 133), rgb(15, 13, 61))"
      }}
    >
      <div className="max-w-3xl">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight text-white">
          Your one stop solution for all{" "}
          <span className="text-yellow-500">IT Services</span>
        </h1>
        <p className="text-lg md:text-2xl mb-8">
          We manage your IT requirements and deliver great customer experience.
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-6">
          <a
            href="#contact"
            className="bg-green-600 text-white font-semibold py-3 px-6 rounded-md shadow-lg hover:bg-green-700 transition"
          >
            Describe requirement
          </a>
          <a
            href="#services"
            className="bg-yellow-400 text-blue-900 font-semibold py-3 px-6 rounded-md shadow-lg hover:bg-yellow-600 transition"
          >
            Our Services
          </a>
        </div>
      </div>
    </section>
  );
}
